import { PortableText } from "@portabletext/react";
import { useLoaderData } from "@remix-run/react";
import { serverOnly$ } from "vite-env-only/macros";
import { createClient } from "@sanity/client";
import urlBuilder from "@sanity/image-url";
import { useMemo } from "react";
import { SiteCache } from "~/cache/SiteCache.server";
import { getPortableTextComponents } from "~/components/potable-component-builder";
import { getArticle } from "~/services/sanityClient.server";

export const articleLoader = serverOnly$(async (request: Request, slug: string) => {
	const article = await getArticle(request, slug);
	if (!article || Object.keys(article).length === 0) {
		throw new Response(null, {
			status: 404,
			statusText: "No article found",
		});
	}
	const siteSettings = await SiteCache.getSettings(request);
	return { article, sanity: siteSettings.sanitySettings, slug };
})
export function ArticleComponent() {
	const { article, sanity } = useLoaderData<typeof articleLoader>();
	const builder = useMemo(() => urlBuilder(createClient(sanity)), [sanity]);
	const components = useMemo(() => getPortableTextComponents(builder), [builder]);
	return <div className="text-slate-700 max-w-6xl pt-12 mx-auto">
		<h1 className="text-7xl font-bold text-center text-black mb-8">{article.headline}</h1>
		<label className="italic text-sm text-center block mb-8">Published by {article.authorName} - {new Date(article.updatedAt).toLocaleDateString(undefined, { dateStyle: "long" })} </label>
		{/* <img style={{ marginRight: 20, marginLeft: 0, marginBottom: 10, width: 550, float: "left" }} src={builder.image(article.image).url()} /> */}
		<PortableText value={article.body} components={components} />
	</div>
}